import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormTitle from '../../../FormFields/FormTitle';
import FormStaffInfoField from '../../../FormFields/StaffInfoField/FormStaffInfoField';
import FormStaffInfoFieldWithContracted from '../../../FormFields/StaffInfoField/FormStaffInfoFieldWithContracted';
import FormStaffInfoFieldWithDiffDept from '../../../FormFields/StaffInfoField/FormStaffInfoFieldWithDiffDept';
import FormStaffAccessInfoField from '../../../FormFields/StaffInfoField/FormStaffInfoFieldAccess';
import { CLINICAL } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';

StaffInformation.propTypes = {
  permissions: PropTypes.object,
};

export default function StaffInformation({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);
  const showForm = [
    CLINICAL.CNA_TRAINING,
    CLINICAL.FLU_VACCINE,
    CLINICAL.NHSN_ACCESS,
    CLINICAL.ADMINISTRATOR,
    CLINICAL.DIRECTOR_OF_NURSING,
    CLINICAL.ADON,
    CLINICAL.INFECTION_CONTROL,
  ].some(({ id }) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Staff Information
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {CLINICAL.CNA_TRAINING.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Does the facility have CNA training classes?' }} />
              <FormButtonOptions
                fieldName={CLINICAL.CNA_TRAINING.fieldName}
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.CNA_TRAINING.id],
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                }}
              />
            </Grid>
          )}
          {CLINICAL.FLU_VACCINE.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Is the flu vaccine mandatory for staff?' }} />
              <FormButtonOptions
                fieldName={CLINICAL.FLU_VACCINE.fieldName}
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.FLU_VACCINE.id],
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                }}
              />
            </Grid>
          )}
          {CLINICAL.NHSN_ACCESS.id in permissions && (
            <Grid item xs={12}>
              <FormStaffAccessInfoField
                fieldName={CLINICAL.NHSN_ACCESS.fieldName}
                allowMultiple
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.NHSN_ACCESS.id],
                  questionTitle: 'Who has NHSN access?',
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
                showToggle={false}
              />
              <Divider sx={{ mb: 2, mt: 2, borderWidth: 1 }} />
            </Grid>
          )}
          {CLINICAL.ADMINISTRATOR.id in permissions && (
            <Grid item xs={12}>
              <FormStaffInfoFieldWithContracted
                fieldName={CLINICAL.ADMINISTRATOR.fieldName}
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.ADMINISTRATOR.id],
                  questionTitle: 'Current administrator',
                  fieldName: CLINICAL.ADMINISTRATOR.fieldName,
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
              <Divider sx={{ mb: 2, mt: 2, borderWidth: 1 }} />
            </Grid>
          )}
          {CLINICAL.DIRECTOR_OF_NURSING.id in permissions && (
            <Grid item xs={12}>
              <FormStaffInfoFieldWithContracted
                fieldName={CLINICAL.DIRECTOR_OF_NURSING.fieldName}
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.DIRECTOR_OF_NURSING.id],
                  questionTitle: 'Current director of nursing',
                  fieldName: CLINICAL.DIRECTOR_OF_NURSING.fieldName,
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
              <Divider sx={{ mb: 2, mt: 2, borderWidth: 1 }} />
            </Grid>
          )}
          {CLINICAL.ADON.id in permissions && (
            <Grid item xs={12}>
              <FormStaffInfoField
                fieldName={CLINICAL.ADON.fieldName}
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.ADON.id],
                  questionTitle: 'Current ADON',
                  fieldName: CLINICAL.ADON.fieldName,
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
              <Divider sx={{ mb: 2, mt: 2, borderWidth: 1 }} />
            </Grid>
          )}
          {CLINICAL.INFECTION_CONTROL.id in permissions && (
            <Grid item xs={12}>
              <FormStaffInfoFieldWithDiffDept
                fieldName={CLINICAL.INFECTION_CONTROL.fieldName}
                fieldAttributes={{
                  isEditable: permissions[CLINICAL.INFECTION_CONTROL.id],
                  questionTitle: 'Current infection control',
                  fieldName: CLINICAL.INFECTION_CONTROL.fieldName,
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
              <Divider sx={{ mb: 2, mt: 2, borderWidth: 1 }} />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
